import { render, staticRenderFns } from "./floor-multi-sector.vue?vue&type=template&id=c2f88f96&scoped=true"
import script from "./floor-multi-sector.vue?vue&type=script&lang=js"
export * from "./floor-multi-sector.vue?vue&type=script&lang=js"
import style0 from "./floor-multi-sector.vue?vue&type=style&index=0&id=c2f88f96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f88f96",
  null
  
)

export default component.exports